module.exports = __webpack_public_path__ + "static/media/italy_paper_mill_getty_desktop.7ae43757.jpg";